import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { faPencilAlt, faTimes } from '@fortawesome/free-solid-svg-icons';
import { faComment } from '@fortawesome/free-regular-svg-icons';
import { int } from 'src/utils/misc.utils';
import 'moment/locale/nb';
import { SearchableDropdown } from '../../components/SearchableDropdown';
import Modal from '../../components/Modal';
import { Block } from '../../components/LayoutBase';
import { capitalize } from '../../utils/string.utils';
import { animalRowVariants, expandCollapseVariants } from './util';
import { InfoBubble } from '../../components/InfoBubble';
import Helptext from '../../components/Helptext';
import Button from '../../components/Button';
import { colorTypes, getBrandingColor } from '../../branding';
import {
  Column, Icon, Label, LineSeparator, LinkLabel, Row,
} from '../../components/Layout';
import { InputChoices, NumericInput } from '../../components/Input';
import {
  AddCommentToggleButton,
  EditComment,
  RegisterStep,
  InputError,
  StepWrapper,
  StepHeader,
  Errors,
  AddNewRowHeader,
  Checkbox,
  AnimalRowWrapper,
  AnimalRowInfo,
  AnimalRowField,
  AnimalRowFieldName,
  AnimalRowCheckmark,
  AnimalRowFieldValue,
  HoverRow,
  ModalCancelButton,
  ModalDangerousActionButton,
  ChooseCattleWrapper,
  subcategoryEqualsIgnoreAgePart,
  SelectSheepCattleDropdownElem,
  CattleOriginMarkAndDelete,
  CheckboxForCattleOption,
  animalKindToNorwegian,
  getReturnSheep,
  CheckboxWithInfoBubble,
  HorizontalCheckboxLine,
  SlaugherSheepMainContentWrapper,
} from './Components';
import {
  cattleKindsSell,
  pigKinds,
  maxCharactersCommentAnimal,
  pigBuySellKinds,
  sheepBuySellKinds,
  maxCharactersReturnMeatPickupLocation,
  cattleKindsSlaughter,
} from './Config';

export const BuySellSheep = ({
  refHeaderWrapper,
  animalRowMode,
  sheepAgeCategoryChoices,
  sheepAgeCategoryValues,
  currentAnimalRow,
  selectedAction,
  onChangeSheepKind,
  onChangeSheepSubKind,
  currentAnimalRowInputErrors,
  profile,
  onChangeSheepIndividualNo,
  onChangeSheepAmount,
  onToggleComment,
  editCommentForCurrAnimalRowProps,
  currAnimalRowIsValid,
  onSubmitOrEditClick,
  onResetAnimalRow,
  currentAnimalRowErrorMsg,
}) => (
  <div>
    <div ref={refHeaderWrapper}>
      <AddNewRowHeader>
        {animalRowMode === 'add' ? 'Ny' : 'Endre'}
        {' '}
        rad for
        {' '}
        {selectedAction === 'buy' ? 'kjøp' : 'salg'}
      </AddNewRowHeader>
    </div>

    <div>
      <RegisterStep
        name="sheep_kind_buy_sell"
        stepNo={3}
        stepHeader="Velg dyr"
        choices={sheepAgeCategoryChoices}
        values={sheepAgeCategoryValues}
        selectedValue={currentAnimalRow.sheep_kind}
        onChange={onChangeSheepKind}
      />

      {currentAnimalRow.sheep_kind && (
        <RegisterStep
          stepHeader="Velg rase"
          inputChoicesTopMargin="0"
          stepNo={4}
          name="choose_sheep_type_buy_sell"
          values={sheepBuySellKinds}
          choices={sheepBuySellKinds}
          selectedValue={currentAnimalRow.sheep_race}
          onChange={onChangeSheepSubKind}
          inputChoicesWidth="unset"
          inputChoicesJustity="unset"
        >
          {currentAnimalRow.sheep_race && (
            <div>
              <div>
                <Column
                  mediumCentered
                  marginTop="1em"
                  alignSelf="center"
                >
                  <Column
                    marginTop="0.5em"
                    marginBottom="0.1em"
                  >
                    {selectedAction === 'slaughter' && (
                      <div>
                        <Label
                          color={getBrandingColor(colorTypes.primary)}
                          name="valuePart"
                          marginBottom="-0.3em"
                        >
                          {profile.profile.provider_no
                            ? 'Produsentnummer:'
                            : 'DyreholdsID:'}
                        </Label>
                        <Label
                          marginTop="0.5em"
                          marginBottom="0.8em"
                        >
                          {profile.profile.provider_no || profile.profile.animal_keeping_id}
                        </Label>
                      </div>
                    )}

                    <Label
                      color={getBrandingColor(colorTypes.primary)}
                      marginBottom="-0.3em"
                    >
                      {selectedAction === 'sell'
                        ? 'Individnr'
                        : 'Antall'}
                    </Label>
                    <div
                      style={{
                        position: 'relative',
                        display: 'flex',
                      }}
                    >
                      <NumericInput
                        min="0"
                        autoComplete="off"
                        name="sheep_individual_no_or_amount"
                        error={
                          selectedAction === 'sell'
                            ? currentAnimalRowInputErrors.sheep_individual_no
                            : currentAnimalRowInputErrors.amount
                        }
                        value={
                          ((selectedAction === 'sell' && currentAnimalRow.sheep_individual_no) || '')
                            || (currentAnimalRow.amount || '')
                        }
                        onChange={
                        (evt) => {
                          if (selectedAction === 'sell') {
                            onChangeSheepIndividualNo(evt.target.value);
                          }

                          if (selectedAction === 'buy') {
                            onChangeSheepAmount(evt.target.value);
                          }
                        }
                  }
                      />

                      {selectedAction === 'sell' && currentAnimalRowInputErrors.sheep_individual_no && (
                        <InputError
                          style={{
                            width: '90px',
                            marginTop: '13px',
                            marginRight: '-0.7em',
                          }}
                          message="Ugyldig individnummer"
                        />
                      )}
                      {selectedAction !== 'sell' && currentAnimalRowInputErrors.amount && (
                        <InputError
                          style={{
                            width: '90px',
                            marginTop: '13px',
                            marginRight: '-0.7em',
                          }}
                          message="Ugyldig antall"
                        />
                      )}
                    </div>

                    <AddCommentToggleButton
                      onToggleComment={onToggleComment}
                    />
                  </Column>
                </Column>
                <EditComment
                  {...editCommentForCurrAnimalRowProps}
                />
              </div>
              <Column
                width="100%"
                marginTop="1.55em"
                style={{ position: 'static' }}
                marginBottom="0.6em"
              >
                <Button
                  primaryCentered
                  type="submit"
                  disabled={!currAnimalRowIsValid}
                  onClick={onSubmitOrEditClick}
                >
                  {animalRowMode === 'add'
                    ? 'Legg til'
                    : 'Endre'}
                </Button>
                <LinkLabel
                  color="#c20000"
                  onClick={onResetAnimalRow}
                  style={{
                    textAlign: 'center',
                    maxWidth: 'max-content',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                  }}
                >
                  {animalRowMode === 'add'
                    ? 'Avbryt radinnleggelse'
                    : 'Avbryt endring'}
                </LinkLabel>
                <Errors
                  errors={currentAnimalRowErrorMsg}
                />
              </Column>
            </div>
          )}
        </RegisterStep>
      )}
    </div>
  </div>
);

const liveAnimalTypeValues = ['feeding_animal', 'breeding_animal'];
const liveAnimalTypeChoices = ['Foringsdyr', 'Avlsdyr'];

// for buying cattle, the user goes trough a step-by-step process
// for each step the user chooses between some options
// what choices are availible are dependent on earlier choices
const buyCattleGetInfoForSteps = ({
  currentAnimalRow,
  setCurrentAnimalRow,
  setCurrentStep,
  onClickStep,
}) => {
  const c = currentAnimalRow;

  const steps = [
    {
      stepNo: 4,
      choices: liveAnimalTypeChoices,
      values: liveAnimalTypeValues,
      selectedValue: currentAnimalRow.live_animal_type,
      header: 'Velg livdyr:',
      onChange: (value) => {
        setCurrentStep(4);

        const animalRow = { ...c };

        delete animalRow.cattle_category;
        delete animalRow.cattle_breeding_fertility_status;
        delete animalRow.cattle_weight;
        delete animalRow.cattle_gender;

        animalRow.live_animal_type = value;

        setCurrentAnimalRow(animalRow);
      },
    },

    {
      stepNo: 5,
      values: ['meat_animal', 'milk_animal'],
      choices: c.live_animal_type === 'feeding_animal'
        ? ['Kjøttfe', 'Melkefe']
        : ['Kjøtt', 'Melk'],
      selectedValue: currentAnimalRow.cattle_category,
      header: 'Velg kategori:',
      onChange: (value) => {
        setCurrentStep(5);
        const animalRow = { ...c };
        delete animalRow.cattle_breeding_fertility_status;
        delete animalRow.cattle_weight;
        delete animalRow.cattle_gender;

        animalRow.cattle_category = value;

        setCurrentAnimalRow(animalRow);

        onClickStep(4);
      },
    },

    {
      stepNo: 6,
      ...(() => {
        const obj = {
          isDone: true,
          values: [],
          choices: [],
          onChange: () => {
          },
        };

        obj.isDone = false;

        if (c.live_animal_type === 'feeding_animal') {
          // light is only option, select this automatically and hide the step
          if (c.cattle_category === 'milk_animal') {
            obj.skip_rendering = true;
            const animalRow = { ...currentAnimalRow };
            // prevent intinite rerendering if this value is already set automatically
            if (animalRow.cattle_weight !== 'light') {
              delete animalRow.cattle_gender;
              animalRow.cattle_weight = 'light';

              setCurrentStep(6);
              setCurrentAnimalRow(animalRow);
            }
          } else if (c.cattle_category === 'meat_animal') {
            const isMilk = c.cattle_category === 'milk_animal';

            obj.values = isMilk ? ['light'] : ['light', 'heavy'];
            obj.choices = isMilk ? ['Lett'] : ['Lett', 'Tung'];
            obj.selectedValue = c.cattle_weight;
            obj.header = 'Velg rase:';
            obj.onChange = (val) => {
              const animalRow = { ...currentAnimalRow };
              delete animalRow.cattle_gender;
              animalRow.cattle_weight = val;

              setCurrentStep(6);
              setCurrentAnimalRow(animalRow);
            };
          }
        }

        if (c.live_animal_type === 'breeding_animal') {
          obj.isDone = false;
          if (c.cattle_category === 'milk_animal') {
            obj.skip_rendering = true;
            const animalRow = { ...currentAnimalRow };

            // prevent intinite rerendering if this value is already set automatically
            if (animalRow.cattle_weight !== 'light') {
              delete animalRow.cattle_gender;
              animalRow.cattle_weight = 'light';

              setCurrentStep(6);
              setCurrentAnimalRow(animalRow);
            }
          } else if (c.cattle_category === 'meat_animal') {
            const isMilk = c.cattle_category === 'milk_animal';
            obj.isDone = false;
            obj.values = isMilk ? ['light'] : ['light', 'heavy'];
            obj.choices = isMilk ? ['Lett'] : ['Lett', 'Tung'];
            obj.selectedValue = c.cattle_weight;
            obj.header = 'Velg rase:';
            obj.onChange = (val) => {
              const animalRow = { ...currentAnimalRow };
              delete animalRow.cattle_gender;
              animalRow.cattle_weight = val;

              setCurrentStep(6);
              setCurrentAnimalRow(animalRow);
            };
          }
        }

        return obj;
      })(),
    },

    {
      stepNo: 7,
      ...(() => {
        const obj = {
          isDone: true,
          values: [],
          choices: [],
          onChange: () => {
          },
        };

        if (
          c.live_animal_type === 'feeding_animal'
          && (c.cattle_category === 'meat_animal' || c.cattle_category === 'milk_animal')
          && (c.cattle_weight === 'light' || c.cattle_weight === 'heavy')
        ) {
          obj.isDone = false;
          obj.header = 'Velg kjønn:';
          obj.choices = ['Oksekalv', 'Kvigekalv'];
          obj.values = ['male', 'female'];
          obj.selectedValue = c.cattle_gender;

          obj.onChange = (val) => {
            setCurrentStep(7);
            setCurrentAnimalRow((old) => ({ ...old, cattle_gender: val }));
          };
        }

        if (c.live_animal_type === 'breeding_animal' && (c.cattle_category === 'meat_animal' || c.cattle_category === 'milk_animal')
          && (c.cattle_weight === 'light' || c.cattle_weight === 'heavy')
        ) {
          obj.isDone = false;
          obj.values = ['fertile_she_cattle', 'fertile_small_she_cattle', 'breeding_ox'];
          obj.choices = ['Drektig ku', 'Drektig kvige', 'Avlsokse'];
          obj.header = 'Velg avl/fertilitets-status:';
          obj.selectedValue = c.cattle_breeding_fertility_status;

          obj.onChange = (val) => {
            setCurrentStep(7);
            setCurrentAnimalRow((old) => ({ ...old, cattle_breeding_fertility_status: val }));
          };
        }

        return obj;
      })(),
    },

    { stepNo: 8, isDone: true },
  ];

  // Adjust the step numbers if some steps are skipped, only used for rendering purposes
  let skippedSteps = 0;

  return steps.map((s) => {
    if (s?.skip_rendering) skippedSteps += 1;

    if (!skippedSteps) return s;

    return {
      ...s,
      adjustedStepNo: s.stepNo - skippedSteps,
    };
  });
};

// for buying cattle, the user goes trough a step-by-step process
// for each step the user chooses between some options
// what choices are availible are dependent on earlier choices
export const BuyCattle = ({
  resetAnimalRow,
  currentAnimalRowErrorMsg,
  editCommentForCurrAnimalRowProps,
  onChangeAmount,
  animalRowMode,
  currentAnimalRowInputErrors,
  hasEnteredDataInFirstStep,
  onGetRefForStep,
  onGetRefForDetailsStep,
  onChoosedOptionInStep,
  currentStep,
  currentAnimalRow,
  setCurrentAnimalRow,
  setCurrentStep,
  onClickStep,
  currAnimalRowIsValid,
  onToggleComment,
  refElemStartOfCustomEnrolmentFlow,
  onSubmitOrEditClick,
}) => {
  const steps = React.useMemo(() => buyCattleGetInfoForSteps({
    currentAnimalRow,
    setCurrentAnimalRow,
    setCurrentStep,
    onClickStep,
  }), [currentAnimalRow, setCurrentAnimalRow, setCurrentStep, onClickStep]);

  return (
    <>
      <div ref={refElemStartOfCustomEnrolmentFlow}>
        <AddNewRowHeader>
          {animalRowMode === 'add' ? 'Ny' : 'Endre'}
          {' '}
          rad for kjøp
        </AddNewRowHeader>
      </div>
      {steps.filter((forStep) => !forStep.skip_rendering).map((forStep) => (currentStep + 1 >= forStep.stepNo && !forStep.isDone && (
        <RegisterStep
          name="cattle_step_3"
          key={`buy_cattle_step_${forStep.stepNo}`}
          stepNo={forStep.adjustedStepNo ?? forStep.stepNo}
          stepHeader={forStep.header}
          values={forStep.values}
          onGetRef={(ref) => onGetRefForStep(ref, forStep)}
          choices={forStep.choices}
          selectedValue={forStep.selectedValue}
          onChange={(value) => onChoosedOptionInStep(value, forStep)}
        />
      )) || (currentStep + 1 >= forStep.stepNo && (
        /* If we have reached the last step, where we enter details */
        <StepWrapper
          background="#F9F9F9"
          borderRadius="0.5em"
          onGetRef={onGetRefForDetailsStep}
          padding="1.5em 2.5em"
          marginTop="2em"
        >
          <Row>
            <Label size="2em" font="serif">
              {forStep.adjustedStepNo ?? forStep.stepNo}
              .
            </Label>
            <StepHeader text="Velg antall" />
          </Row>
          <div>
            <Column
              mediumCentered
              marginTop="1em"
              alignSelf="center"
              name="animalDetails"
            >
              <Column
                as="label"
                marginTop="0.5em"
                marginBottom="0.1em"
              >
                <Label
                  color={getBrandingColor(colorTypes.primary)}
                  marginBottom="-0.3em"
                >
                  Antall:
                </Label>
                <div
                  style={{
                    position: 'relative',
                    display: 'flex',
                  }}
                >
                  <NumericInput
                    min="1"
                    autoComplete="off"
                    name="animalcount"
                    error={currentAnimalRowInputErrors.amount}
                    value={currentAnimalRow.amount || ''}
                    onChange={(evt) => onChangeAmount(evt.target.value)}
                  />
                  {currentAnimalRowInputErrors.amount && (
                    <InputError
                      message="Ugyldig antall"
                      top="14px"
                    />
                  )}
                </div>
                <AddCommentToggleButton
                  onToggleComment={onToggleComment}
                />
              </Column>
            </Column>
            <EditComment {...editCommentForCurrAnimalRowProps} />
          </div>
          <Column
            width="100%"
            marginTop="1.55em"
            style={{ position: 'static' }}
            marginBottom="0.6em"
          >
            <Button
              primaryCentered
              type="submit"
              disabled={!currAnimalRowIsValid}
              onClick={onSubmitOrEditClick}
            >
              {animalRowMode === 'add'
                ? 'Legg til'
                : 'Endre'}
            </Button>
            <LinkLabel
              color="#c20000"
              onClick={resetAnimalRow}
              style={{
                textAlign: 'center',
                maxWidth: 'max-content',
                marginLeft: 'auto',
                marginRight: 'auto',
              }}
            >
              {animalRowMode === 'add'
                ? 'Avbryt radinnleggelse'
                : 'Avbryt endring'}
            </LinkLabel>
            <Errors errors={currentAnimalRowErrorMsg} />
          </Column>
        </StepWrapper>
      )))}

      {/* if the user has selected something in the first step */}
      {hasEnteredDataInFirstStep && (
        <LinkLabel
          style={{
            textDecoration: 'underline',
            position: 'relative',
            color: '#466faa',
            left: '50%',
            width: 'fit-content',
            transform: 'translateX(-50%)',
          }}
          onClick={resetAnimalRow}
        >
          Avbryt
        </LinkLabel>
      )}

    </>
  );
};

/*
Registration of pigs for slaughter, buy or sell.
Dependent on the configuration and kind of pig choosed for registration, pigs can be
registered either as groups (with club no and amount) or as individuals (with ear tag).
For individual registration return meat is set using a checkbox, for groups, the user specifies the number of return meat
*/

export const SlaughterBuySelllPigs = ({
  selectedAction,
  selectedAnimalSubGroup,
  isPigsWithIndividualRegistration,
  currentAnimalRowInputErrors,
  currentAnimalRow,
  animalRowMode,
  editCommentForCurrAnimalRowProps,
  onChangeReturnMeatAmount,
  onToggleComment,
  onChangeReturnMeatCheckedPigGroup,
  onChangeReturnMeatCheckedIndividualPig,
  onChangeEarTagIndividualPig,
  onChangeAmount,
  onChangePigKind,
  onChangeClubNoPigGroup,
  onChangeHasHealthRemarksPigGroup,
  onChangeHealthRemarksAmount,
  onChangeHasHealthRemarksIndividualPig,
}) => (
  <Column>
    {(selectedAction === 'buy' || selectedAction === 'sell') && (
      <div>
        <p
          style={{
            display: 'inline-block',
            margin: '0',
            marginTop: '0.8em',
          }}
        >
          SPF
        </p>
        <Helptext
          name="spf"
          render={(text) => text && (
            <InfoBubble
              style={{
                marginTop: '0.4em',
                marginLeft: '0.2em',
              }}
              popupStyle={{
                transform: 'none',
                width: '80%',
                minWidth: '14em',
              }}
            >
              <p>{text}</p>
            </InfoBubble>
          )}
        />
      </div>
    )}
    <Row marginTop="1em" align="center" width="100%">
      <InputChoices
        smallbuttons
        ignoreInForm
        name=""
        flexBasis="33%"
        justify="center"
        choices={selectedAction === 'slaughter'
          ? pigKinds
          : pigBuySellKinds}
        values={selectedAction === 'slaughter'
          ? pigKinds
          : pigBuySellKinds}
        value={selectedAnimalSubGroup}
        onChange={(selected) => onChangePigKind(selected)}
      />
    </Row>
    {selectedAnimalSubGroup && (
      <div>
        <Column
          mediumCentered
          marginTop="1em"
          alignSelf="center"
        >
          {selectedAction === 'slaughter' && !isPigsWithIndividualRegistration && (
            <Column as="label">
              <Label
                color={getBrandingColor(colorTypes.primary)}
                marginBottom="-0.3em"
              >
                Klubbenummer:
              </Label>
              <div
                style={{
                  position: 'relative',
                  display: 'flex',
                }}
              >
                <NumericInput
                  min="0"
                  error={currentAnimalRowInputErrors.club_no}
                  value={currentAnimalRow.club_no || ''}
                  onChange={(evt) => onChangeClubNoPigGroup(evt.target.value)}
                />
                {currentAnimalRowInputErrors.club_no && (
                  <InputError
                    message="Ugyldig nummer"
                    top="19px"
                  />
                )}
              </div>
            </Column>
          )}

          { (!isPigsWithIndividualRegistration || (isPigsWithIndividualRegistration && animalRowMode === 'add')) && (
            <Column as="label">
              <Label
                color={getBrandingColor(colorTypes.primary)}
                marginBottom="-0.3em"
              >
                Antall:
              </Label>
              <div
                style={{
                  position: 'relative',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <NumericInput
                  min="1"
                  autoComplete="off"
                  name="animalcount"
                  error={currentAnimalRowInputErrors.amount}
                  value={currentAnimalRow.amount || ''}
                  onChange={(evt) => {
                    onChangeAmount(evt.target.value);
                  }}
                />
                {currentAnimalRowInputErrors.amount && (
                  <InputError
                    message="Ugyldig antall"
                    top="19px"
                  />
                )}
              </div>
            </Column>
          )}

          <Column
            marginTop="0.5em"
            marginBottom="0.1em"
          >
            {isPigsWithIndividualRegistration && animalRowMode === 'add' && (
              <div>
                <div
                  style={{
                    position: 'relative',
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >

                  <motion.div
                    style={{ marginTop: '1em', ...currentAnimalRow.amount === 1 ? { paddingBottom: '3.8em' } : {} }}
                    variants={expandCollapseVariants}
                    animate={currentAnimalRow.amount
                                                && currentAnimalRow.amount > 0
                      ? 'visible'
                      : 'collapsed'}
                  >
                    {animalRowMode === 'add' && currentAnimalRow.amount && Array(currentAnimalRow.amount)
                      .fill()
                      .map((e, i, arr) => {
                        /* adjust the position of the popup so always visible.
                        To make this happen we place it below the bubble, unless its the last or second last bubble in the list.
                        The first and only bubble is placed in the middle, same with the first of two bubbles.  */

                        const positionAbove = '-144px';
                        const positionMiddle = '-83px';
                        const positionBellow = '30px';

                        let positionTop = positionBellow;
                        if (i === 0 && arr.length === 1) {
                          positionTop = positionMiddle;
                        } else if (arr.length === 2 && i === 0) {
                          positionTop = positionMiddle;
                        } else if (i + 1 === arr.length || i + 2 === arr.length) {
                          positionTop = positionAbove;
                        }

                        return (
                          <div>
                            <Label
                              color={getBrandingColor(colorTypes.primary)}
                              marginTop="1em"
                              marginBottom="-0.3em"
                            >
                              Øremerke:
                            </Label>

                            <div
                              style={{
                                position: 'relative',
                                display: 'flex',
                              }}
                            >
                              <NumericInput
                                name={`ear_tag_pig_no${i}`}
                                min="1"
                                error={currentAnimalRowInputErrors.individual_pigs
                                  && currentAnimalRowInputErrors.individual_pigs[i] && currentAnimalRowInputErrors
                                  .individual_pigs[i]
                                  .ear_tag}
                                value={(currentAnimalRow.individual_pigs && currentAnimalRow.individual_pigs[i]
                                && currentAnimalRow
                                  .individual_pigs[i]
                                  .ear_tag)}
                                onChange={(evt) => {
                                  onChangeEarTagIndividualPig(evt.target.value, i);
                                }}
                              />

                              {currentAnimalRowInputErrors.individual_pigs
                                  && currentAnimalRowInputErrors.individual_pigs[i]
                                  && currentAnimalRowInputErrors
                                    .individual_pigs[i]
                                    .ear_tag && (
                                      <InputError
                                        message="Ugyldig nummer"
                                        top="19px"
                                      />
                              )}
                            </div>

                            <div style={{ display: 'flex', width: '286px', marginTop: '0.1em' }}>
                              <div style={{ marginRight: '0.6em' }}>
                                <Checkbox
                                  label="Returkjøtt"
                                  name={`return_meat_individual_pigs${i}`}
                                  checked={currentAnimalRow
                                    .individual_pigs[i]
                                    .return_meat}
                                  onChange={(evt) => onChangeReturnMeatCheckedIndividualPig(evt.target.checked, i)}
                                />
                              </div>
                              <CheckboxWithInfoBubble
                                infoBubbleHelptextKey="health_remarks"
                                popupStyle={{ left: '-210px', top: positionTop }}
                                popupStyleMobile={{ left: '-36vw' }}
                                label="Har helseavvik"
                                name={`has_health_remarks_individual_pigs${i}`}
                                checked={currentAnimalRow
                                  .individual_pigs[i]
                                  .has_health_remarks}
                                onChange={(evt) => onChangeHasHealthRemarksIndividualPig(evt.target.checked, i)}
                              />
                            </div>
                          </div>
                        );
                      })}
                  </motion.div>
                </div>
              </div>
            )}
            {isPigsWithIndividualRegistration && animalRowMode === 'edit' && (
              <div>
                <div
                  style={{
                    position: 'relative',
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <div>
                    <Label
                      color={getBrandingColor(colorTypes.primary)}
                      marginTop="1em"
                      marginBottom="-0.3em"
                    >
                      Øremerke:
                    </Label>

                    <div
                      style={{
                        position: 'relative',
                        display: 'flex',
                      }}
                    >
                      <NumericInput
                        min="0"
                        error={currentAnimalRowInputErrors.ear_tag}
                        value={currentAnimalRow.ear_tag}
                        onChange={(evt) => {
                          onChangeEarTagIndividualPig(evt.target.value);
                        }}
                      />

                      {currentAnimalRowInputErrors.ear_tag && (
                        <InputError
                          message="Ugyldig nummer"
                          top="19px"
                        />
                      )}
                    </div>

                    <div>
                      <Checkbox
                        label="Returkjøtt"
                        name="return_meat_individual_pigs"
                        checked={currentAnimalRow.return_meat}
                        onChange={(evt) => { onChangeReturnMeatCheckedIndividualPig(evt.target.checked); }}
                      />
                    </div>
                    <div style={{ marginTop: '0.5rem', marginBottom: '1rem' }}>
                      <Checkbox
                        label="Har helseavvik"
                        name="has_health_remarks_individual_pigs"
                        checked={currentAnimalRow.has_health_remarks}
                        onChange={(evt) => { onChangeHasHealthRemarksIndividualPig(evt.target.checked); }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
            {selectedAction === 'slaughter' && !isPigsWithIndividualRegistration && (
              <div>
                <Label
                  inline
                  style={{
                    marginBottom: '1.5em',
                    marginTop: '1em',
                  }}
                >
                  <Checkbox
                    label="Returkjøtt"
                    name="return_meat_pig"
                    checked={currentAnimalRow.return_meat_checked}
                    onChange={(evt) => onChangeReturnMeatCheckedPigGroup(evt.target.checked)}
                  />
                </Label>
                <motion.div
                  key="return_meat_pig"
                  variants={expandCollapseVariants}
                  animate={
                                            currentAnimalRow.return_meat_checked
                                              ? 'visible'
                                              : 'collapsed'
                                        }
                  initial="collapsed"
                >
                  <div style={{ marginLeft: '1em' }}>
                    <Label
                      color={getBrandingColor(colorTypes.primary)}
                      marginBottom="-0.3em"
                    >
                      Antall:
                    </Label>
                    <NumericInput
                      min="1"
                      max={currentAnimalRow.amount}
                      autoComplete="off"
                      style={{
                        marginBottom: '0.5em',
                      }}
                      name="input_return_meat_pig"
                      value={currentAnimalRow.return_meat}
                      onChange={(evt) => onChangeReturnMeatAmount(evt.target.value)}
                    />
                  </div>
                </motion.div>

                <Label
                  inline
                  style={{
                    marginBottom: '1.5em',
                  }}
                >
                  <Checkbox
                    label="Har helseavvik"
                    name="has_health_remarks"
                    checked={currentAnimalRow.has_health_remarks}
                    onChange={(evt) => onChangeHasHealthRemarksPigGroup(evt.target.checked)}
                    css={{ marginTop: 0 }}
                  />
                </Label>

                <Helptext
                  name="health_remarks"
                  render={(text) => text && (
                    <InfoBubble
                      popupStyle={{
                        position: 'absolute',
                        top: '26px',
                        left: '-120px',
                        minWidth: '12em',
                      }}
                      style={{
                        marginBottom: '0.8em',
                        marginLeft: '0.3em',
                        position: 'relative',
                      }}
                    >
                      <span dangerouslySetInnerHTML={{ __html: text }} />
                    </InfoBubble>
                  )}
                />
                <motion.div
                  key="has_health_remarks_pig"
                  variants={expandCollapseVariants}
                  animate={
                    currentAnimalRow.has_health_remarks
                      ? 'visible'
                      : 'collapsed'
                  }
                  initial="collapsed"
                >
                  <div style={{ marginLeft: '1em' }}>
                    <Label
                      color={getBrandingColor(colorTypes.primary)}
                      marginBottom="-0.3em"
                    >
                      Antall dyr med helseavvik:
                    </Label>
                    <NumericInput
                      min="1"
                      max={currentAnimalRow.amount}
                      autoComplete="off"
                      style={{
                        marginBottom: '0.5em',
                      }}
                      name="input_return_meat_pig"
                      value={currentAnimalRow.health_remarks_cnt}
                      onChange={(evt) => onChangeHealthRemarksAmount(evt.target.value)}
                    />
                  </div>
                </motion.div>

              </div>
            )}

            <AddCommentToggleButton
              style={{ marginTop: '0.4em' }}
              onClick={onToggleComment}
            >
              Legg til kommentar
            </AddCommentToggleButton>
          </Column>
        </Column>
        <EditComment
          {...editCommentForCurrAnimalRowProps}
        />
      </div>
    )}
  </Column>
);

// list of animals/grouops of animals added to the enrolment, these animals will be registered on submit
export const AnimalRows = ({
  animalRows,
  selectedAnimalGroup,
  selectedAction,
  indexAnimalRowToEdit,
  animalRowShowCommentForRowNo,
  onCloseComment,
  onToggleComment,
  indexAnimalRowToShowDeleteConfirmation,
  onCancelDelete,
  onConfirmDelete,
  onDeleteAnimalRow,
  onCLickEditRow,
  selectedAnimalSubGroup,
}) => {
  const getIndexAnimalRowsByReverseIndex = (reverseIndex) => animalRows.length - 1 - reverseIndex;

  return (
    <StepWrapper name="animalRowsWrapper">
      <AnimatePresence>
        {animalRows
          .slice(0)
          .reverse()
          .map(
            (row, index) => row && (({
              subcategory_name,
              club_no,
              amount,
              mark_no,
              individual_no,
              provider_no,
              animal_keeping_id,
              comment,
              hidden,
              uid,
              return_meat,
              return_skin,
              is_sheep_cut,
              horn,
              pregnant,
              ear_tag,

              /* for buy cattle not in readable form */
              animal_kind,
              live_animal_type,
              cattle_category,
              cattle_weight,
              cattle_gender,
              cattle_breeding_fertility_status,

              sheep_kind,
              sheep_individual_no,
              sheep_race,
              return_sheep,

              has_health_remarks,
              health_remarks_cnt,
            }) => !hidden && (
              <motion.div
                key={uid || subcategory_name + amount + sheep_race + index}
                initial={animalRowVariants.exit}
                positionTransition
                animate={animalRowVariants.enter}
                exit={animalRowVariants.exit}
              >
                {!selectedAnimalSubGroup && (
                  <LineSeparator />
                )}
                <AnimalRowWrapper
                  name="animalRowWrapper"
                >
                  <Row
                    grow
                    align="center"
                    marginLeft="0.15em"
                    marginRight="0.15em"
                  >
                    {!(
                      selectedAnimalGroup === 'sheep' && (selectedAction === 'buy' || selectedAction === 'sell')
                    ) && (
                      <div>
                        <Label
                          color="#000000"
                          bold
                          style={{ width: '92px' }}
                          size="1.4em"
                        >
                          {capitalize(
                            subcategory_name || animalKindToNorwegian(animal_kind),
                          )}
                        </Label>
                        {live_animal_type && (
                          <Label
                            color="#000000"
                            size="1.1em"
                            marginTop="0.2em"
                          >
                            {capitalize(
                              live_animal_type === 'feeding_animal'
                                ? 'Foringsdyr'
                                : 'Avlsdyr',
                            )}
                          </Label>
                        )}
                      </div>
                    )}

                    {selectedAnimalGroup === 'sheep' && (selectedAction === 'buy' || selectedAction === 'sell') && (
                      <div>
                        <Label
                          color="#000000"
                          bold
                          style={{ width: '80px' }}
                          size="1.4em"
                        >
                          {sheep_kind === 'lamb'
                            ? 'Lam'
                            : sheep_kind === 'vaer'
                              ? 'Vær'
                              : 'Sau'}
                        </Label>
                        <Label
                          color="#000000"
                          size="1.1em"
                          marginTop="0.2em"
                        >
                          {capitalize(sheep_race)}
                        </Label>
                      </div>
                    )}
                    <Row
                      name="animalRowDetails"
                      marginLeft="6em"
                      style={{
                        flexGrow: 1,
                        flexWrap: 'wrap',
                        flexBasis: '70%',
                        marginLeft: '2%',
                      }}
                    >
                      {amount && (
                        <AnimalRowInfo
                          label="Antall: "
                          value={amount}
                        />
                      )}

                      {ear_tag && (
                        <AnimalRowInfo
                          label="Ørenummer:"
                          value={ear_tag}
                        />
                      )}

                      {cattle_category && (
                        <AnimalRowInfo
                          label="Kategori:"
                          value={live_animal_type === 'feeding_animal'
                            ? cattle_category === 'milk_animal'
                              ? 'Melkefe'
                              : 'Kjøttfe'
                            : cattle_category === 'milk_animal'
                              ? 'Melk'
                              : 'Kjøtt'}
                        />
                      )}

                      {cattle_weight && (
                        <AnimalRowInfo
                          label="Vekt:"
                          value={cattle_weight === 'light'
                            ? 'Lett'
                            : 'Tung'}
                        />
                      )}

                      {cattle_gender && (
                        <AnimalRowInfo
                          label="Kjønn:"
                          value={cattle_gender === 'male'
                            ? 'Oksekalv'
                            : 'Kvigekalv'}
                        />
                      )}

                      {cattle_breeding_fertility_status && (
                        <AnimalRowInfo
                          label="Avl/fertilitetsstatus:"
                          labelStyle={{
                            display: 'block',
                            wordBreak: 'break-all',
                          }}
                          value={cattle_breeding_fertility_status === 'fertile_she_cattle'
                            ? 'Drektig ku'
                            : cattle_breeding_fertility_status === 'fertile_small_she_cattle'
                              ? 'Drektig kvige'
                              : 'Avlsokse'}
                        />
                      )}

                      {is_sheep_cut === true && (
                        <AnimalRowInfo
                          label="Klippet"
                          withCheckmark
                          labelStyle={{ fontWeight: 'normal' }}
                        />
                      )}
                      {return_meat === true && (
                        <AnimalRowInfo
                          label="Returkjøtt"
                          withCheckmark
                          labelStyle={{ fontWeight: 'normal' }}
                          noSpaceAfterLabel
                        />
                      )}
                      {has_health_remarks === true && Number.isNaN(int(health_remarks_cnt)) && (
                        <AnimalRowInfo
                          label="Helseavvik"
                          withCheckmark
                          labelStyle={{ fontWeight: 'normal' }}
                          noSpaceAfterLabel
                        />
                      )}
                      {selectedAnimalGroup !== 'cattle' && selectedAnimalGroup !== 'sheep' && Number.isNaN(return_skin) === false && return_skin > 0
                      && (
                        <AnimalRowInfo
                          label="Returskinn:"
                          value={return_skin}
                        />
                      ) }

                      {horn === true && (
                        <AnimalRowInfo
                          label="Horn"
                          noSpaceAfterLabel
                          withCheckmark
                        />
                      )}
                      {pregnant === true && (
                        <AnimalRowInfo
                          label="Drektig"
                          withCheckmark
                          noSpaceAfterLabel
                        />
                      ) }

                      {return_skin === true && (
                        <AnimalRowField>
                          <AnimalRowFieldName>
                            <AnimalRowCheckmark />
                          </AnimalRowFieldName>
                          <AnimalRowFieldValue
                            style={{ fontWeight: 'normal' }}
                          >
                            {cattleKindsSlaughter
                              .map((e) => e.toLowerCase()).concat(cattleKindsSlaughter.map((e) => `ung ${e.toLowerCase()}`))
                              .indexOf(subcategory_name.toLowerCase()) >= 0
                              ? ' Returhud'
                              : ' Returskinn'}
                          </AnimalRowFieldValue>
                        </AnimalRowField>
                      )}

                      {Array.isArray(return_meat) && return_meat.length > 0 && (
                        <AnimalRowInfo
                          label="Returkjøtt:"
                          value={return_meat.length}
                        />
                      )}
                      {Array.isArray(return_skin) && return_skin.length > 0 && (
                        <AnimalRowInfo
                          label="Returskinn:"
                          value={return_skin.length}
                        />
                      )}

                      {Number.isNaN(int(return_meat)) === false && return_meat > 0 && (
                        <AnimalRowInfo
                          label="Returkjøtt:"
                          value={return_meat}
                        />
                      )}

                      {Number.isNaN(int(return_meat)) === false && return_skin > 0 && (
                        <AnimalRowInfo
                          label="Returskinn:"
                          value={return_skin}
                        />
                      )}

                      { ((Number.isNaN(int(health_remarks_cnt)) === false && int(health_remarks_cnt) > 0) || (getReturnSheep(row) && getReturnSheep(row).filter((a) => a.has_health_remarks).length > 0)) && (
                        <AnimalRowInfo
                          label="Dyr med helseavvik:"
                          value={(int(health_remarks_cnt) || 0) + ((getReturnSheep(row) && getReturnSheep(row).filter((a) => a.has_health_remarks).length) || '')}
                        />
                      )}
                      <Block
                        name="animalRowRightPart"
                        style={{
                          display: 'flex',
                          marginRight: '1em',
                          flexWrap: 'wrap',
                        }}
                      >
                        {club_no && (
                          <AnimalRowInfo
                            label="Klubbenummer:"
                            value={club_no}
                          />
                        )}
                        {mark_no && individual_no && (
                          <div
                            name="animalRowCattleMark"
                            style={{ display: 'flex' }}
                          >
                            <AnimalRowFieldName name="animalRowCattleMarkHeader">
                              Merkenr / Individnr:
                            </AnimalRowFieldName>

                            <div
                              name="animalRowCattleMarkData"
                              name="valuePart"
                            >
                              <Label inline style={{ verticalAlign: 'baseline' }}>
                                {mark_no}
                                {' '}
                                /
                                {' '}
                              </Label>
                              <Label inline style={{ verticalAlign: 'baseline' }}>
                                {individual_no}
                              </Label>
                            </div>
                          </div>
                        )}

                        {sheep_individual_no && (
                          <AnimalRowInfo
                            label="Individnr:"
                            value={sheep_individual_no}
                          />
                        )}

                        {animal_keeping_id && (
                          <AnimalRowInfo
                            label="DyreholdsID:"
                            noSpaceAfterLabel
                            value={animal_keeping_id}
                          />
                        )}
                        {provider_no && (
                          <AnimalRowInfo
                            label="Produsentnr"
                            noSpaceAfterLabel
                            value={provider_no}
                            name="splitLinesOnMobile"
                          />
                        )}
                      </Block>
                    </Row>
                  </Row>
                  <Row
                    name="actionButtonsRow"
                    paddingTop="0.35em"
                    marginLeft="0.1em"
                    marginRight="0.1em"
                  >
                    {getIndexAnimalRowsByReverseIndex(index)
                                      !== indexAnimalRowToEdit && (
                                        <Row grow>
                                          <LinkLabel>
                                            <HoverRow
                                              style={{
                                                fontSize: '0.85rem',
                                              }}
                                              onClick={() => onCLickEditRow(index)}
                                            >
                                              <Icon
                                                size="1.4em"
                                                marginRight="0.4em"
                                                icon={faPencilAlt}
                                              />
                                              <Label textDecoration="underline">
                                                Rediger
                                              </Label>
                                            </HoverRow>
                                          </LinkLabel>
                                        </Row>
                    )}
                    <Row
                      grow
                      aria-hidden={!comment}
                      style={{
                        opacity: comment ? 1 : 0,
                        pointerEvents: comment
                          ? 'initial'
                          : 'none',
                      }}
                      justify="center"
                    >
                      <LinkLabel>
                        <Row
                          style={{
                            fontSize: '0.85rem',
                          }}
                        >
                          <Icon
                            size="1.4em"
                            marginRight="0.4em"
                            icon={faComment}
                          />
                          <Label
                            textDecoration="underline"
                            onClick={() => {
                              onToggleComment(index);
                            }}
                          >
                            Kommentar
                          </Label>

                          {animalRowShowCommentForRowNo
                                                           === index && (
                                                             <Column>
                                                               <Modal
                                                                 closable
                                                                 noEscape
                                                                 onClose={() => {
                                                                   onCloseComment();
                                                                 }}
                                                                 height="fit-content"
                                                                 width="80%"
                                                                 style={{
                                                                   minHeight: '12%',
                                                                   maxWidth: '700px',
                                                                 }}
                                                               >
                                                                 <p>{comment}</p>
                                                               </Modal>
                                                             </Column>
                          )}
                        </Row>
                      </LinkLabel>
                    </Row>
                    <Row grow justify="flex-end">
                      {indexAnimalRowToShowDeleteConfirmation
                        === index && (
                          <Modal>
                            <Label
                              size="1.15em"
                              padding="1.5em"
                            >
                              Er du sikker på å slette
                              denne raden?
                            </Label>

                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'row',
                                fontSize: '1.15em',
                                justifyContent: 'center',
                              }}
                            >
                              <ModalCancelButton
                                onClick={onCancelDelete}
                              >
                                Nei
                              </ModalCancelButton>
                              <ModalDangerousActionButton
                                style={{
                                  marginLeft: '1em',
                                }}
                                onClick={onConfirmDelete}
                              >
                                Ja
                              </ModalDangerousActionButton>
                            </div>
                          </Modal>
                      )}
                      {getIndexAnimalRowsByReverseIndex(index)
                                                   !== indexAnimalRowToEdit && (
                                                     <HoverRow
                                                       onClick={() => onDeleteAnimalRow(
                                                         animalRows.length
                                                                   - index
                                                                   - 1,
                                                       )}
                                                       style={{
                                                         fontSize: '0.85rem',
                                                         color: getBrandingColor(colorTypes.primary),
                                                       }}
                                                     >
                                                       <Icon
                                                         size="1.4em"
                                                         marginRight="0.4em"
                                                         icon={faTimes}
                                                       />
                                                       <Label
                                                         textDecoration="underline"
                                                         role="button"
                                                       >
                                                         Slett
                                                       </Label>
                                                     </HoverRow>
                      )}
                    </Row>
                  </Row>
                </AnimalRowWrapper>
              </motion.div>
            ))(row),
          )}
      </AnimatePresence>
    </StepWrapper>
  );
};

export const SLaughterSheep = ({
  sheepKinds,
  selectedAnimalSubGroup,
  onChangeSheepKind,
  profile,
  currentAnimalRow,
  currentAnimalRowInputErrors,
  currentRowReturnSheeep,
  onToggleComment,
  editCommentForCurrAnimalRowProps,
  onCheckIsSheepCut,
  onCheckHasReturnSkin,
  onCheckHasReturnMeat,
  onChangeReturnAnimalIndividualNo,
  onChangeAmountReturnAnimals,
  onChangeAmountSheep,
  onChangeHasHealthRemarksSheep,
  onChangeHealthRemarksAmountSheep,
}) => (
  <div>
    <Row marginTop="1em" align="center" width="100%">
      <InputChoices
        smallbuttons
        ignoreInForm
        name=""
        flexBasis="33%"
        justify="center"
        choices={sheepKinds}
        values={sheepKinds}
        value={selectedAnimalSubGroup}
        onChange={onChangeSheepKind}
      />
    </Row>
    <Column marginTop="1em" align="center">
      {selectedAnimalSubGroup && (
        <Column
          as="label"
          style={{
            position: 'relative',
            width: '200px',
          }}
        >
          <Label color={getBrandingColor(colorTypes.primary)} marginBottom="-0.3em">
            {profile.profile.animal_keeping_id
              ? 'DyreholdsID:'
              : 'Produsentnummer:'}
          </Label>
          <Label marginTop="0.5em" marginBottom="0.8em">
            {profile.profile.animal_keeping_id
                            || profile.profile.provider_no}
          </Label>
        </Column>
      )}
      {selectedAnimalSubGroup && (
        <div>
          <SlaugherSheepMainContentWrapper
            mediumCentered
            marginTop="0.5em"
            marginBottom="0.1em"
          >
            <>
              <Label
                color={getBrandingColor(colorTypes.primary)}
                marginBottom="-0.3em"
              >
                Antall:
              </Label>
              <NumericInput
                max="200"
                name="amountSheep"
                autoComplete="off"
                marginBottom="2em"
                style={{ width: '219px' }}
                value={currentAnimalRow.amount}
                error={currentAnimalRowInputErrors.amount}
                onChange={(evt) => onChangeAmountSheep(evt.target.value)}
              />
              {currentAnimalRowInputErrors.amount && (
                <InputError
                  message="Ugyldig antall"
                  top="19px"
                />
              )}

              <Label
                color={getBrandingColor(colorTypes.primary)}
                marginBottom="-0.3em"
              >
                Antall retur:
              </Label>
              <NumericInput
                max="200"
                name="amountSheepReturn"
                autoComplete="off"
                marginBottom="2em"
                style={{ width: '219px' }}
                value={(currentAnimalRow.return_sheep && currentRowReturnSheeep.length) || ''}
                onChange={(evt) => { onChangeAmountReturnAnimals(evt.target.value); }}
              />

              {Array.isArray(
                currentAnimalRow.return_sheep,
              ) && Array(currentRowReturnSheeep.length)
                .fill()
                .map((a, i) => (
                  <div
                    key={i}
                    style={{
                      width: 'fit-content',
                      marginBottom: '1em',
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        marginTop: '1em',
                        marginBottom: '1em',
                      }}
                    >
                      <Label
                        color={getBrandingColor(colorTypes.primary)}
                        marginBottom="-0.3em"
                      >
                        Individnr:
                      </Label>

                      <div
                        style={{
                          position: 'relative',
                        }}
                      >
                        <NumericInput
                          min="0"
                          style={{
                            marginBottom: '1.05em',
                            width: '200px',
                          }}
                          name={`sheepNo${i}individual_no`}
                          value={currentAnimalRow.return_sheep[i].individual_no}
                          onChange={(e) => {
                            onChangeReturnAnimalIndividualNo(e.target.value, i);
                          }}
                        />
                        {currentAnimalRowInputErrors && currentAnimalRowInputErrors.individualNumbers && currentAnimalRowInputErrors
                          .individualNumbers[
                            currentAnimalRow
                              .return_sheep[i]
                              .individual_no
                          ] && (
                            <InputError
                              style={{
                                width: '100px',
                                position: 'absolute',
                                marginTop: '-3px',
                                top: '13px',
                                right: '0',
                                left: '29%',
                              }}
                              message="Ugyldig individnummer"
                            />
                        )}
                      </div>

                      <HorizontalCheckboxLine
                        wrapOnSmall
                      >
                        <span
                          className="checkbox-wrapper"
                        >
                          <Checkbox
                            label="Returkjøtt"
                            name={`return_meat_sheep_no${i - 1}`}
                            checked={currentAnimalRow.return_sheep[i].return_meat}
                            onChange={(evt) => {
                              onCheckHasReturnMeat(evt.target.checked, i);
                            }}
                          />
                        </span>
                        <span
                          className="checkbox-wrapper"
                        >
                          <Checkbox
                            label="Returskinn"
                            name={`return_skin_sheep_no${i - 1}`}
                            checked={currentAnimalRow.return_sheep[i].return_skin}
                            onChange={(evt) => {
                              onCheckHasReturnSkin(evt.target.checked, i);
                            }}
                          />
                        </span>
                        <span
                          className="checkbox-wrapper"
                        >
                          <CheckboxWithInfoBubble
                            label="Har helseavvik"
                            infoBubbleHelptextKey="health_remarks"
                            name={`has_health_remarks_sheep_no${i - 1}`}
                            checked={currentAnimalRow.return_sheep[i].has_health_remarks}
                            onChange={(evt) => {
                              onChangeHasHealthRemarksSheep(evt.target.checked, i);
                            }}
                          />

                        </span>
                      </HorizontalCheckboxLine>

                      {currentAnimalRowInputErrors
                                                && currentAnimalRowInputErrors.invalidReturn
                                                && currentAnimalRowInputErrors
                                                  .invalidReturn[
                                                    currentAnimalRow
                                                      .return_sheep[i]
                                                      .individual_no
                                                  ] && (
                                                    <InputError
                                                      style={{
                                                        position: 'relative',
                                                        margin: '0',
                                                        background: 'none',
                                                      }}
                                                      message="Du må velge enten returkjøtt eller returskinn"
                                                    />
                      )}
                    </div>

                    <LineSeparator desktopStyle={{ width: 'calc(100% - 16px)' }} mobileStyle={{ width: '199px' }} />
                  </div>
                ))}
            </>

            <div style={{ marginBottom: '0.6rem', marginTop: '0.5rem' }}>

              { getReturnSheep(currentAnimalRow).length !== int(currentAnimalRow.amount) && (
                <Label
                  inline
                  style={{
                    marginBottom: '1.5em',
                    marginTop: '1em',
                    position: 'relative',
                    marginLeft: '0.3em',
                  }}
                >
                  <CheckboxWithInfoBubble
                    label={currentAnimalRow.return_sheep
                    && getReturnSheep(currentAnimalRow).length > 0 ? 'Dyr uten retur har helseavvik' : 'Har helseavvik'}
                    name="has_health_remarks"
                    checked={currentAnimalRow.has_health_remarks || currentAnimalRow.health_remarks_cnt}
                    onChange={(evt) => onChangeHasHealthRemarksSheep(evt.target.checked)}
                    css={{ marginTop: '1rem', marginBottom: '1.5rem' }}
                    infoBubbleHelptextKey="health_remarks"
                  />

                </Label>
              )}

              <motion.div
                key="health_remarks_checked"
                variants={expandCollapseVariants}
                animate={
                  currentAnimalRow.has_health_remarks
                    ? 'visible'
                    : 'collapsed'
                }
                initial="collapsed"
              >
                <Column as="label" marginLeft="1em">
                  <Label
                    color={getBrandingColor(colorTypes.primary)}
                    marginBottom="-0.3em"
                  >
                    Antall dyr med helseavvik:
                  </Label>
                  <div
                    style={{
                      position: 'relative',
                      display: 'flex',
                      flexDirection: 'column',
                    }}
                  >
                    <NumericInput
                      min="1"
                      style={{ width: 'fit-content' }}
                      autoComplete="off"
                      name="animalcount"
                      error={currentAnimalRowInputErrors.health_remarks_cnt}
                      value={currentAnimalRow.health_remarks_cnt}
                      onChange={(evt) => {
                        onChangeHealthRemarksAmountSheep(evt.target.value);
                      }}
                    />
                    {currentAnimalRowInputErrors.health_remarks_cnt && (
                      <InputError
                        message="Ugyldig antall"
                        top="19px"
                      />
                    )}
                  </div>
                </Column>
              </motion.div>
            </div>

            {['kje'].indexOf(
              selectedAnimalSubGroup.toLowerCase(),
            ) === -1 && (
              <Label
                inline
                style={{
                  marginBottom: '0.6em',
                  marginTop: '-0.3em',
                  position: 'relative',
                  marginLeft: '0.3em',
                }}
              >
                <Checkbox
                  name="is_sheep_cut"
                  label="Er dyrene klipt"
                  checked={currentAnimalRow.is_sheep_cut}
                  onChange={(evt) => {
                    onCheckIsSheepCut(evt.target.checked);
                  }}
                />
                <Helptext
                  name="is-sheep-cut"
                  render={(text) => text && (
                    <InfoBubble
                      aria-label="Info om 'er sauen klipt'?"
                      popupStyle={{
                        left: '-120px',
                      }}
                      style={{
                        marginBottom: '0.8em',
                        marginLeft: '0.3em',
                      }}
                    >
                      <p>{text}</p>
                    </InfoBubble>
                  )}
                />
              </Label>
            )}

            <AddCommentToggleButton
              style={{ marginTop: '1em' }}
              onToggleComment={onToggleComment}
            />
          </SlaugherSheepMainContentWrapper>
          <EditComment
            {...editCommentForCurrAnimalRowProps}
          />
        </div>
      )}
    </Column>
  </div>
);

const getCattleOptions = (selectedAction) => {
  const kinds = selectedAction === 'slaughter'
    ? cattleKindsSlaughter
    : cattleKindsSell;

  return {
    choices: ['Alle'].concat(kinds),
    values: ['all_kinds'].concat(kinds.map((e) => e.toLowerCase())),
  };
};

/*
select one or more cattles, possibly add comment and check return meat/return skin and add the cattle
 */
export const SlaughterSellCattle = ({
  animalRowMode,
  selectedAnimalSubGroup,
  disabledCattleKindsValues,
  onChangeCattleKind,
  animals,
  keySelectCattle,
  cattleForDropdownForCurrFilters,
  onToggleShowOnlySelectedInDropdown,
  dropdownItemName,
  onCloseDropdown,
  onChoosedCattleInDropdown,
  selectedCattleDropdownForEditMode,
  currentAnimalRow,
  selectedAction,
  onCheckHorn,
  onCheckReturnSkinMeat,
  onCheckPregnant,
  onToggleComment,
  onDeleteCattle,
  selectedMultipleItemsIdentifiers,
  onCheckHasHealthRemarks,
  onChangeComment,
  onSubmitChoosedCattleInDropdown,
  animalRows,
  indexAnimalRowToEdit,
}) => {
  const cattleOptions = React.useMemo(() => getCattleOptions(selectedAction), [selectedAction]);

  const getCattleForCurrentrow = () => {
    if (animalRowMode === 'add') {
      return currentAnimalRow.cattle
        ? Object.getOwnPropertyNames(currentAnimalRow.cattle)
        : [];
    }
    return currentAnimalRow.mark_no && currentAnimalRow.individual_no
      ? [currentAnimalRow]
      : [];
  };

  return (
    <Column alignSelf="center" align="center" name="selectCattle">
      <Label
        italic
        style={{
          alignSelf: 'start', marginTop: '0.8em', marginBottom: '-1em', marginLeft: '0.3em',
        }}
      >
        {animalRowMode === 'add' ? 'Filtrer på type' : 'Velg type'}
      </Label>
      <Row
        marginTop="1em"
        align="center"
        width="100%"
        style={{ minWidth: '290px' }}
      >
        {/* For adding cattle, the kind selection functions like a filter. When swtiching between subkinds, other selected cattle
                              are kept, but not shown. If 'Alle'(all) is choosed, all selected cattle are shown.
        */}
        <InputChoices
          smallbuttons
          ignoreInForm
          flexBasis="33%"
          justify="center"
          name="animalgg"
          choices={cattleOptions.choices}
          values={cattleOptions.values}
          value={selectedAnimalSubGroup}
          disabledValues={disabledCattleKindsValues}
          onChange={onChangeCattleKind}
        />
      </Row>
      {selectedAnimalSubGroup && (
        <ChooseCattleWrapper>
          <Label marginBottom="0.2em">
            {animalRowMode === 'add'
              ? 'Velg et eller flere dyr fra din storfebesetning' : 'Velg et dyr fra din storfebesetning'}
          </Label>
          {(animals.error && (
            <Label>Kunne ikke laste inn storfe</Label>
          )) || (
            <div>
              {animalRowMode === 'add' && (
                <SearchableDropdown
                  selectedModeTooltip="Valgte storfe av alle typer:"
                  multiSelect
                  preventCloseOnFocusLoss
                  key={keySelectCattle}
                  itemSearchKey="display"
                  multiSelectIdentifierKey="uid"
                  multiSelectItemName={dropdownItemName}
                  dataitems={cattleForDropdownForCurrFilters}
                  smallScreenwidth="96%"
                  bigScreenWidth="350px"
                  bigScreenHeight="600px"
                  smallScreenHeight="300px"
                  renderSelectedItemInInput={(item) => item.display}
                  placeholder="Søk etter merkenr eller individnr"
                  onShowSelectedModeChange={onToggleShowOnlySelectedInDropdown}
                  onClose={onCloseDropdown}
                  selectMultipleSelectedIdentifiersChanged={onChoosedCattleInDropdown}
                  selectedMultipleItemsIdentifiers={selectedMultipleItemsIdentifiers}
                  onMultiselectChoosedItems={onSubmitChoosedCattleInDropdown}
                  renderItem={(
                    item,
                    searchTerm,
                    itemHasFocus,
                    itemIsChoosed,
                  ) => (
                    <SelectSheepCattleDropdownElem
                      itemIsChoosed={itemIsChoosed}
                      key={item.display}
                      searchTerm={searchTerm}
                      itemHasFocus={itemHasFocus}
                      item={item}
                    />
                  )}
                />
              )}

              {animalRowMode === 'edit' && (
                <SearchableDropdown
                  dataitems={cattleForDropdownForCurrFilters}
                  itemSearchKey="display"
                  smallScreenwidth="96%"
                  bigScreenWidth="350px"
                  bigScreenHeight="600px"
                  smallScreenHeight="300px"
                  renderSelectedItemInInput={(item) => (item ? item.display : '')}
                  placeholder="Velg storfe"
                  selectedItem={selectedCattleDropdownForEditMode}
                  onSelectedChange={onChoosedCattleInDropdown}
                  renderItem={(
                    item,
                    searchTerm,
                    itemHasFocus,
                  ) => (
                    <SelectSheepCattleDropdownElem
                      key={item.display}
                      searchTerm={searchTerm}
                      itemHasFocus={itemHasFocus}
                      item={item}
                    />
                  )}
                />
              )}

              <div style={{ marginTop: '1em' }}>
                {getCattleForCurrentrow().length > 0 && (
                  <div>
                    {// key for add mode, a single cattle for edit-mode
                    getCattleForCurrentrow().map(
                      (keyOrCattle) => (
                        <div>
                          <CattleOriginMarkAndDelete
                            style={{
                              justifyContent: 'space-between',
                            }}
                          >
                            <Column>
                              <Label color={getBrandingColor(colorTypes.primary)}>
                                Opprinnelsesmerke:
                              </Label>
                            </Column>
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'row',
                              }}
                            >
                              {animalRowMode === 'add' && (
                                <HoverRow
                                  onClick={() => onDeleteCattle(keyOrCattle)}
                                >
                                  <div
                                    style={{
                                      display: 'flex',
                                    }}
                                  >
                                    <Icon
                                      size="1.4em"
                                      marginRight="0.4em"
                                      color={getBrandingColor(colorTypes.primary)}
                                      icon={faTimes}
                                    />
                                    <Label
                                      textDecoration="underline"
                                      color={getBrandingColor(colorTypes.primary)}
                                      role="button"
                                    >
                                      Slett
                                    </Label>
                                  </div>
                                </HoverRow>
                              )}
                            </div>
                          </CattleOriginMarkAndDelete>
                          <Row marginBottom="0.5em">
                            {animalRowMode === 'add'
                              ? `(${capitalize(currentAnimalRow.cattle[keyOrCattle].subcategory_name)}) ${currentAnimalRow.cattle[keyOrCattle].mark_no} / ${currentAnimalRow.cattle[keyOrCattle].individual_no}`
                              : `(${capitalize(currentAnimalRow.subcategory_name)}) ${currentAnimalRow.mark_no} / ${currentAnimalRow.individual_no}`}
                          </Row>

                          {selectedAction === 'slaughter' && (
                            <HorizontalCheckboxLine wrapOnSmall>
                              <span
                                className="checkbox-wrapper"
                              >
                                <CheckboxForCattleOption
                                  label="Returkjøtt"
                                  dataKey="return_meat"
                                  cattleKey={keyOrCattle}
                                  animalRowMode={animalRowMode}
                                  onCheck={(checked, cattleKey, dataKey) => onCheckReturnSkinMeat(checked, cattleKey, dataKey)}
                                  currentAnimalRow={currentAnimalRow}
                                />
                              </span>

                              <span
                                className="checkbox-wrapper"
                              >
                                <CheckboxForCattleOption
                                  label="Returhud"
                                  dataKey="return_skin"
                                  cattleKey={keyOrCattle}
                                  onCheck={onCheckReturnSkinMeat}
                                  animalRowMode={animalRowMode}
                                  currentAnimalRow={currentAnimalRow}
                                />
                              </span>

                              <span
                                className="checkbox-wrapper"
                              >
                                <CheckboxForCattleOption
                                  label="Har helseavvik"
                                  dataKey="has_health_remarks"
                                  cattleKey={keyOrCattle}
                                  onCheck={onCheckHasHealthRemarks}
                                  animalRowMode={animalRowMode}
                                  currentAnimalRow={currentAnimalRow}
                                  withInfoBubble={{ key: 'health_remarks' }}
                                />
                              </span>

                            </HorizontalCheckboxLine>
                          )}

                          {selectedAction === 'sell' && (
                            <Checkbox
                              name={`horn:${animalRowMode === 'add'
                                ? currentAnimalRow.cattle[keyOrCattle].individual_no + currentAnimalRow.cattle[keyOrCattle].mark_no
                                : currentAnimalRow.individual_no}${currentAnimalRow.mark_no}`}
                              checked={animalRowMode === 'add'
                                ? currentAnimalRow.cattle[keyOrCattle].horn
                                : currentAnimalRow.horn}
                              label="Horn"
                              onChange={(evt) => onCheckHorn(evt.target.checked, keyOrCattle)}
                            />
                          )}
                          {selectedAction === 'sell' && (subcategoryEqualsIgnoreAgePart(animalRowMode === 'add'
                            ? currentAnimalRow.cattle[keyOrCattle].subcategory_name
                            : currentAnimalRow.subcategory_name, 'kvige')
                            || subcategoryEqualsIgnoreAgePart(animalRowMode === 'add'
                              ? currentAnimalRow.cattle[keyOrCattle].subcategory_name
                              : currentAnimalRow.subcategory_name, 'ku')
                          ) && (
                            <span style={{ marginLeft: '1.2em' }}>
                              <Checkbox
                                name={`pregnant:${animalRowMode === 'add'
                                  ? currentAnimalRow.cattle[keyOrCattle].individual_no + currentAnimalRow.cattle[keyOrCattle].mark_no
                                  : currentAnimalRow.individual_no}${currentAnimalRow.mark_no}`}
                                checked={animalRowMode === 'add'
                                  ? currentAnimalRow.cattle[keyOrCattle].pregnant
                                  : currentAnimalRow.pregnant}
                                label="Drektig"
                                onChange={(evt) => {
                                  onCheckPregnant(evt.target.checked, keyOrCattle);
                                }}
                              />
                            </span>
                          )}

                          <AddCommentToggleButton
                            style={{
                              width: '100%',
                              display: 'block',
                              textAlign: 'left',
                              marginTop: '0.3em',
                            }}
                            onToggleComment={() => onToggleComment(keyOrCattle)}
                          />
                          <EditComment
                            key={keyOrCattle}
                            maxLength={maxCharactersCommentAnimal}
                            comment={animalRowMode === 'add'
                              ? currentAnimalRow.cattle[keyOrCattle].comment
                              : currentAnimalRow.comment}
                            showComment={(() => {
                              if (animalRowMode === 'add') {
                                return currentAnimalRow.cattle[keyOrCattle].showComment;
                              } else {
                                return (
                                  currentAnimalRow.showComment || (animalRows[indexAnimalRowToEdit] && animalRows[indexAnimalRowToEdit].comment)
                                );
                              }
                            })()}
                            onChangeComment={(comment) => onChangeComment(comment, keyOrCattle)}
                            onToggleComment={() => onToggleComment(keyOrCattle)}
                            style={{
                              marginTop: '0.5em',
                            }}
                          />
                          <LineSeparator
                            marginTop="0.5em"
                            marginBottom="0.9em"
                          />
                        </div>
                      ),
                    )
}
                  </div>
                )}
              </div>
            </div>
          )}
        </ChooseCattleWrapper>
      )}
    </Column>
  );
};

export const SpecifyReturnMeatPickupLocation = ({ comment, onChangeComment }) => (
  <div style={{ marginTop: '1rem' }}>
    <EditComment
      showComment
      maxLength={maxCharactersReturnMeatPickupLocation}
      commentProps={{ placeholder: 'Hentested' }}
      onChangeComment={onChangeComment}
      comment={comment || ''}
    />
  </div>
);
